export default __webpack_public_path__ + "static/media/Crown_UI.b07e2905.svg";